import { render, staticRenderFns } from "./OcorrenciasAppTable.vue?vue&type=template&id=6c2a87b2&"
import script from "./OcorrenciasAppTable.vue?vue&type=script&lang=js&"
export * from "./OcorrenciasAppTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports